import { useState, Fragment } from "react";
import { FormattedMessage as FM } from "react-intl";
import { Menu, Transition } from "@headlessui/react";

import { FunnelIcon, XMarkIcon } from "components/Icons";
import { useTable } from "storev2/tableStore";

import { cn } from "tools/ui";

function FilterTable({ layout, storeId }) {
  const { reload } = useTable();
  const [selectedOption, setSelectedOption] = useState(null);
  const filterTags = layout.filters() ?? null;

  if (!filterTags) return null;

  async function handleFilter(valueDom) {
    console.log("valueDom", valueDom);
    await reload(storeId, { filter: valueDom });
  }

  function onClick(name, valueDom) {
    setSelectedOption(name);
    handleFilter(valueDom);
  }

  function handleRemoveFilter(e) {
    e.stopPropagation();
    setSelectedOption(null);
    handleFilter(null);
  }

  const items = [];
  for (const [k, v] of Object.entries(filterTags)) {
    items.push(
      <Menu.Item key={k} onClick={() => onClick(k, v)}>
        {({ active }) => (
          <div
            key={v.id}
            className={cn(
              active ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block px-4 py-2 text-sm",
            )}
          >
            <FM id={`${layout.model}.${k}`} />
          </div>
        )}
      </Menu.Item>,
    );
  }

  return (
    <Menu as="div" className="relative text-left h-10 my-auto w-[250px]">
      <div className="flex my-auto h-full">
        <Menu.Button className="inline-flex items-center w-full justify-between h-10 my-auto shadow-sm rounded-xl bg-white px-2.5 py-2 focus-within:border focus-within:border-cyan-500 text-neutral-500">
          {selectedOption ? (
            <div className="bg-blue-100 rounded-md px-2 pt-0.5">
              <p className="text-sm text-blue-500">
                <FM id={`${layout.model}.${selectedOption}`} />
              </p>
            </div>
          ) : (
            <p className="text-md text-neutral-400">
              <FM id="board.filter" />
            </p>
          )}
          {!selectedOption ? (
            <FunnelIcon className="my-auto h-5 w-5 text-neutral-500 fill-current active:scale-95" />
          ) : (
            <div className="relative -right-1">
              <XMarkIcon
                className="my-auto h-7 w-7 text-neutral-500 fill-current active:scale-95"
                onClick={handleRemoveFilter}
              />
            </div>
          )}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-neutral-200 ring-opacity-5 focus:outline-none">
          <div className="py-1">{items}</div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default FilterTable;
